import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../button';
import { IntegrationOpsSC } from './integration.styled';
import { ModalTitleSC, ModalCopySC } from '../modal/modal.styled';

type TProps = {
  onProceed(): void;
  onChoose(software: string): void;
  onOther(): void;
};

const integrationOps = ['CGM', 'Medicom', 'Softprogres', 'Stapro'];

const IntegrationOptions: React.FC<TProps> = ({ onProceed, onChoose, onOther }) => (
  <div>
    <ModalTitleSC>
      <FormattedMessage id="integration.options_step.title" />
    </ModalTitleSC>
    <ModalCopySC>
      <FormattedMessage id="integration.options_step.copy" />
    </ModalCopySC>
    <IntegrationOpsSC>
      {integrationOps.map((software) => (
        <div key={software} className={software !== 'CGM' ? 'disabled' : ''}>
          <h3>{software}</h3>
          <ModalCopySC>
            <FormattedMessage id="integration.integration" />
          </ModalCopySC>
          <Button
            isBlock
            kind="PRIMARY"
            onClick={software === 'CGM' ? () => onChoose(software) : () => {}}
            disabled={software !== 'CGM'}
          >
            <FormattedMessage id="integration.choose" />
          </Button>
        </div>
      ))}
    </IntegrationOpsSC>
    <div className="other-software">
      <ModalCopySC>
        <FormattedMessage id="integration.options_step.other_copy" />
      </ModalCopySC>
      <Button size="SM" onClick={onOther}>
        <FormattedMessage id="integration.options_step.other_button" />
      </Button>
    </div>
    <Button isBlock onClick={onProceed}>
      <FormattedMessage id="integration.options_step.proceed_withoout" />
    </Button>
  </div>
);

export default IntegrationOptions;
